import { useTranslation } from "gatsby-plugin-react-i18next";
import { useState } from "react";
import GridItem from "../../components/general/GridItem";
import Reviews from "../../components/general/Reviews";
import Review from "../../components/general/Reviews/components/Review/Review";
import ReviewGrid from "../../components/general/Reviews/components/ReviewGrid/ReviewGrid";
import ReviewSlider from "../../components/general/Reviews/components/ReviewSlider/ReviewSlider";

export type ReviewType = NonNullable<
	NonNullable<Queries.ReviewsModuleFragment["reviews"]>[number]
>;

const ReviewsModule = ({ reviews }: Queries.ReviewsModuleFragment) => {
	const { t } = useTranslation();

	const [[dir, index], setTuple] = useState([0, 0]);

	const onLeftClick = () => {
		if (reviews) setTuple([-1, index === 0 ? reviews.length - 1 : index - 1]);
	};

	const onRightClick = () => {
		if (reviews) setTuple([1, index === reviews.length - 1 ? 0 : index + 1]);
	};

	return (
		<GridItem>
			<Reviews
				label={t("testimonials")}
				hideButtons={false}
				onLeftClick={onLeftClick}
				onRightClick={onRightClick}
				prevLabel={t("previous")}
				nextLabel={t("next")}
			>
				{reviews && reviews[index] !== null && (
					<>
						<ReviewSlider
							activeReview={reviews[index] as ReviewType}
							dir={dir}
						/>
						<ReviewGrid>
							{reviews
								.slice(0, 2)
								.map(
									(review) =>
										review?.rating && (
											<Review
												key={review._uid}
												rating={review.rating}
												title={review.title || ""}
												quote={review.quote || ""}
												name={review.name || ""}
											/>
										),
								)}
						</ReviewGrid>
					</>
				)}
			</Reviews>
		</GridItem>
	);
};
export default ReviewsModule;
